<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            订单列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>

                    <div style="float:right">
                        <el-select v-model="goodsClassCode" clearable placeholder="请选择商品所属分类" style="margin:0 10px">
                            <el-option
                                    v-for="item in goodsClassValue"
                                    :key="item.goodsClassCode"
                                    :label="item.name"
                                    :value="item.goodsClassCode">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="serialNumber" label="订单流水号" width="300"></el-table-column>
                        <el-table-column prop="elderlyName" label="老人姓名" width="85"></el-table-column>
                        <el-table-column prop="elderlyIdCard" label="身份证号" width="200"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].goodsName" label="商品名称" width="150"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].goodsPrice" label="单价(元)" width="105"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].number" label="购买数量"></el-table-column>
                        <el-table-column prop="price" label="总价(元)" width="105"></el-table-column>
                        <el-table-column
                                prop="isSchedule"
                                :formatter="isSchedules"
                                label="预订单">
                        </el-table-column>
                        <el-table-column prop="serve.name" label="服务人员" width="85"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="下单时间"></el-table-column>
                        <el-table-column prop="orderServe.startTime" :formatter="getSETime" width="200" label="服务开始时间"></el-table-column>
                        <el-table-column prop="orderServe.endTime" :formatter="getSETime" width="200" label="服务结束时间"></el-table-column>
                        <el-table-column
                                prop="orderType"
                                :formatter="statusTitle"
                                label="订单类型" width="150">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                :formatter="statuss"
                                label="订单状态">
                        </el-table-column>
                        <!-- <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column> -->

                        <!-- <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column> -->

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-bind:goodsClassValue="goodsClassValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:goodsClassValue="goodsClassValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                goodsClassCode:'',
                name:null,
                businessCode:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                imgUrl:this.$imgUrl,
                th:0,
                goodsClassValue:[],

            }
        },
        // components:{
        //     Add,Edit
        // },
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init:function(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.goodsClassValue = response.data.data;
                            console.log(this.goodsClassValue)
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            getSETime(row, column, cellValue){
                if(cellValue){
                    var time=timefilters(cellValue);
                    if(time=='1970-01-01 08:00:00'){
                        return ''
                    }else{
                        return timefilters(cellValue)
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        // businessCode:this.businessCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfoOrderBusinessDTO.list;
                        this.totalItems = response.data.data.pageInfoOrderBusinessDTO.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }



        }
    }
</script>

<style scoped>

</style>
